import { render, staticRenderFns } from "./medkon_sentiment_post.vue?vue&type=template&id=20876d24"
import script from "./medkon_sentiment_post.vue?vue&type=script&lang=js"
export * from "./medkon_sentiment_post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports